import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useParams, useSearchParams } from 'react-router-dom';
import { getMABAA112, postMABAA110Invoice, postMABAA110Payment, putMABAA111, putMABAA112 } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import { MESSAGE } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas } from '../../../utils';

const MABAA110 = () => {
    const actDateRef = useRef();
    const cancelDateRef = useRef();
    const { id } = useParams();
    const [searchParams] = useSearchParams();

    const pagePayment = Number(searchParams.get('page-payment')) || 1;
    const pageInvoice = Number(searchParams.get('page-invoice')) || 1;

    const [dataPayment, setDataPayment] = useState([]);
    const [valueRadio, setValueRadio] = useState(null);
    const [popupData, setPopupData] = useState({});
    const [pagesPayment, setPagesPayment] = useState({});
    const [dataInvoice, setDataInvoice] = useState([]);
    const [pagesInvoice, setPagesInvoice] = useState({});
    const [isPopupVisible, setIsPopupVisile] = useState(false);
    const [isPopupDocInfo, setIsPopupDocInfo] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    const [actDate, setActDate] = useState(null);
    const [cancelDate, setCancelDate] = useState(null);
    const [actDateDisable, setActDateDisable] = useState(true);
    const [cancelDateDisable, setCancelDateDisable] = useState(true);

    const [cancelInputValue, setCancelInputValue] = useState('');
    const [chargeInputValue, setChargeInputValue] = useState('');
    const [cancelInputDisable, setCancelInputDisable] = useState(true);
    const [chargeInputDisable, setChargeInputDisable] = useState(true);

    const resetPopup = () => {
        setActDateDisable(true);
        setCancelDateDisable(true);
        setCancelInputDisable(true);
        setChargeInputDisable(true);
        setActDate(null);
        setCancelDate(null);
        setCancelInputValue('');
        setChargeInputValue('');
    };

    const handleOpen = (seq) => {
        resetPopup();
        setSelectedData(seq);
        setIsPopupVisile(true);
        const data = dataPayment.find((item) => item.seq === seq);
        setPopupData(data);
    };

    const handleClose = () => {
        setSelectedData(null);
        setIsPopupVisile(false);
        setPopupData(null);
    };

    const handleChangeInput = (e) => {
        const value = e.target.value;
        if (valueRadio === 'cancel') {
            setCancelInputValue(value);
        } else if (valueRadio === 'rdo') {
            setChargeInputValue(value);
        }
    };
    const handleDateChange = (date, name) => {
        if (name === 'actDate') {
            setActDate(date);
        } else if (name === 'cancelDate') {
            setCancelDate(date);
        }
    };

    const handleRadioChange = (e) => {
        resetPopup();
        const value = e.target.value;
        setValueRadio(value);
        setActDateDisable(value !== 'act');
        setCancelDateDisable(value !== 'cancel');
        setCancelInputDisable(value !== 'cancel');
        setChargeInputDisable(value !== 'rdo');
    };

    const getPaymentMethod = (payMethod) => {
        switch (payMethod) {
            case 'VCard':
                return '신용카드';
            case 'Card':
                return '카드';
            case 'VBank':
                return '가상계좌';
            case 'EMTICKET':
                return 'Dvmall 이용권';
            case 'DirectBank':
                return '계좌이체';
            default:
                return '';
        }
    };

    const getCshrtype = (cshrtype) => {
        switch (cshrtype) {
            case '0':
                return '소득공제';
            case '1':
                return '지출증빙';
            case '7':
                return '발급완료';
            case '9':
                return '세금계산서';
            default:
                return '';
        }
    };

    const handleSave = () => {
        if (!valueRadio) {
            window.alert('결제취소나 계좌정보변경을 선택해 주세요.');
            return;
        }
        if (valueRadio === 'act' && !actDate) {
            window.alert('결제일을 선택해 주세요.');
            return;
        }

        if (valueRadio === 'cancel' && !cancelDate) {
            window.alert('취소일을 선택해 주세요.');
            return;
        }
        if (valueRadio === 'cancel' && cancelDate && cancelInputValue === '') {
            window.alert('취소 사유를 입력해 주세요.');
            return;
        }
        if (valueRadio === 'rdo' && chargeInputValue === '') {
            window.alert('입금자명을 입력해 주세요.');
            return;
        }

        const isConfirmed = window.confirm('결제정보를 취소/변경 하시겠습니까?');
        if (isConfirmed) {
            const year = cancelDate?.getFullYear();
            const month = cancelDate?.getMonth();
            const day = cancelDate?.getDate();
            const momentToSendUTC = moment.utc([year, month, day]);
            const customFormatToSend = momentToSendUTC.format('YYYY-MM-DD HH:mm:ss');
            const applDate = actDate ? moment(actDate).format('YYYYMMDD') : null;
            const payload = {
                seq: popupData.seq,
                type: valueRadio,
                applDate: applDate !== null ? applDate : '',
                cancelDate: cancelDate !== null ? customFormatToSend : '',
                cancelMsg: cancelInputValue,
                aCTInputName: chargeInputValue,
            };

            putMABAA111(payload)
                .then(() => {
                    window.alert(MESSAGE.notify.updateSuccess);
                    handleClose();
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error);
                    window.alert(MESSAGE.notify.updateError);
                });
        }
    };

    useEffect(() => {
        postMABAA110Payment(id, { page: pagePayment })
            .then(({ data }) => {
                setDataPayment(data.recruitPayments);
                setPagesPayment(data.info);
            })
            .catch((error) => console.log(error));
    }, [id, pagePayment]);

    useEffect(() => {
        postMABAA110Invoice(id, { page: pageInvoice })
            .then(({ data }) => {
                setDataInvoice(data.data);
                setPagesInvoice(data.info);
            })
            .catch((error) => console.log(error));
    }, [id, pageInvoice]);

    const emailDomainArr = [
        { option: 'gmail.com', value: 'gmail.com' },
        { option: 'hanmail.net', value: 'hanmail.net' },
        { option: 'hotmail.com', value: 'hotmail.com' },
        { option: 'msn.com', value: 'msn.com' },
        { option: 'nate.com', value: 'nate.com' },
        { option: 'naver.com', value: 'naver.com' },
        { option: 'netian.com', value: 'netian.com' },
        { option: 'yahoo.com', value: 'yahoo.com' },
        { option: '직접입력', value: 'zdirect' },
    ];
    const [formData, setFormData] = useState({
        useOpt: '',
        chargerName: '',
        buyerTel: '',
        emailPart1: '',
        emailPart2: '',
        emailDomain: '',
        buyerEmail: '',
        receiptNum: '',
        cshrTid: '',
        cshrApplNum: '',
        cshrType: '',
    });
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => {
            const newData = {
                ...prevData,
                [name]: value,
            };

            if (name === 'emailPart2') {
                const domainOptions = emailDomainArr.map((option) => option.value);
                if (domainOptions.includes(value)) {
                    newData.emailDomain = value;
                }
            }

            if (['emailPart1', 'emailPart2'].includes(name)) {
                newData.buyerEmail =
                    newData.emailPart1 && newData.emailPart2
                        ? `${newData.emailPart1 || ''}@${newData.emailPart2 || ''}`
                        : '';
            }

            return newData;
        });
    };
    const handleEmailDomainChange = (e) => {
        const selectedValue = e.target.value;
        const updatedEmailPart2 = selectedValue === 'zdirect' ? '' : selectedValue;
        const updatedEmail = `${formData?.emailPart1 || ''}@${updatedEmailPart2}`;

        setFormData((prevData) => ({
            ...prevData,
            emailDomain: selectedValue,
            emailPart2: updatedEmailPart2,
            buyerEmail: updatedEmail,
        }));
    };

    const handleEditInfo = (seq) => {
        setIsPopupDocInfo(true);
        getMABAA112(seq)
            .then((res) => {
                setFormData(res.data);
                if (res.data.buyerEmail) {
                    const [emailPart1, emailPart2] = res.data.buyerEmail.split('@');
                    const domainOptions = emailDomainArr.map((option) => option.value);
                    const emailDomain = domainOptions.includes(emailPart2) ? emailPart2 : 'zdirect';
                    setFormData((prev) => ({ ...prev, emailPart1, emailPart2, emailDomain }));
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const handleCloseDocInfo = () => {
        setIsPopupDocInfo(false);
    };
    const handleUpdateInfo = () => {
        delete formData.emailPart1;
        delete formData.emailPart2;
        delete formData.emailDomain;

        putMABAA112(formData)
            .then(() => {
                window.alert('증빙서류 정보를 수정했습니다.');
                handleCloseDocInfo();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className="profile-content">
            <div className="title-profile">결제 및 증빙 내역</div>
            <div id="profile-payment-history" style={{ overflow: 'scroll' }}>
                <div className="title-table">결제 내역</div>
                <div className="profile-content-count">
                    총 <span className="total">{formatNumberWithCommas(pagesPayment?.totalRow || 0)}</span>건
                </div>
                <table className="table-gray profile-payment">
                    <thead>
                        <tr>
                            <th style={{ width: '6%' }}>신청일</th>
                            <th style={{ width: '10%' }}>
                                상품명
                                <br />
                                채용광고Seq,
                                <br />
                                결제Seq
                            </th>
                            <th style={{ width: 'auto' }}>결제금액</th>
                            <th style={{ width: '10%' }}>결제여부</th>
                            <th style={{ width: '6%' }}>취소일</th>
                            <th style={{ width: '7%' }}>결제수단</th>
                            <th style={{ width: '15%' }}>
                                TID
                                <br />
                                주문번호
                            </th>
                            <th style={{ width: 'auto' }}>
                                입금은행
                                <br />
                                입금계좌
                            </th>
                            <th style={{ width: '7%' }}>입금자명</th>
                            <th style={{ width: '9%' }}>계좌만료일</th>
                            <th style={{ width: '7%' }}>증빙구문</th>
                            <th style={{ width: '5%' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataPayment && dataPayment.length > 0 ? (
                            dataPayment.map((item, index) => {
                                const paymentMethod = getPaymentMethod(item?.payMethod);
                                return (
                                    <tr key={'payment' + index}>
                                        <td>{formatDate(item?.applDate)}</td>
                                        <td>
                                            <div className="itemName">{item?.goodName}</div>
                                            <div className="groupSeq">
                                                <span className="itemRefSeq">{item?.refSeq}</span>,
                                                <span className="itemSeq"> {item?.seq}</span>
                                            </div>
                                        </td>
                                        <td>{formatNumberWithCommas(item?.totPrice)}</td>
                                        <td>
                                            {item?.cancelFlag === 'Y' ? (
                                                <>
                                                    결제취소
                                                    <br />({item?.cancelMsg})
                                                </>
                                            ) : item?.resultCode === '00' ? (
                                                <>
                                                    결제완료
                                                    <br />({item?.applTime})
                                                </>
                                            ) : (
                                                '미결제'
                                            )}
                                        </td>
                                        <td>{item?.cancelFlag === 'N' ? '' : formatDate(item?.cancelDate)}</td>
                                        <td>
                                            <div className="payMethod">{paymentMethod}</div>
                                        </td>
                                        <td>
                                            <div className="tid">{item?.tid}</div>
                                            <div className="moid">{item?.moid}</div>
                                        </td>
                                        <td>
                                            {item?.vactbankCode}
                                            <br />
                                            {item?.vactnum}
                                        </td>
                                        <td>{item?.vactinputName}</td>
                                        <td>
                                            {item?.vactdate
                                                ? moment(item?.vactdate, 'YYYYMMDD').format('YYYY.MM.DD')
                                                : ''}
                                        </td>
                                        <td>{getCshrtype(item?.cshrtype)}</td>
                                        <td>
                                            <span id="popup-payment-history" onClick={() => handleOpen(item?.seq)}>
                                                변경
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={12}>데이타가 없습니다.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <Pagination pages={pagesPayment} params="page-payment" />
            </div>

            <div id="profile-payment-history">
                <div className="title-table">증빙 내역</div>
                <div className="profile-content-count">
                    총 <span className="total">{formatNumberWithCommas(pagesInvoice?.totalRow || 0)}</span>건
                </div>
                <table className="table-gray">
                    <thead>
                        <tr>
                            <th style={{ width: '8%' }}>
                                신청일
                                <br />
                                채용광고Seq
                            </th>
                            <th>
                                결제여부
                                <br />
                                TID <br />
                                주문번호
                            </th>

                            <th style={{ width: '8%' }}>증빙구분</th>
                            <th style={{ width: '8%' }}>
                                합계
                                <br /> 공급가액
                                <br /> 부가서
                            </th>
                            <th style={{ width: '10%' }}>
                                상호
                                <br /> 등록번호
                                <br /> 성명
                            </th>
                            <th style={{ width: '9%' }}>
                                주소
                                <br /> 업태
                                <br /> 업종
                            </th>
                            <th style={{ width: '20%' }}>이메일</th>
                            <th style={{ width: '5%' }} />
                        </tr>
                    </thead>
                    <tbody>
                        {dataInvoice && dataInvoice.length > 0 ? (
                            dataInvoice.map((item, index) => {
                                return (
                                    <tr key={'invoice' + index}>
                                        <td>
                                            <div>{formatDate(item?.applDate)}</div>
                                            <div>{item?.refSeq}</div>
                                        </td>
                                        <td>
                                            <div>{item?.resultCode === '00' ? '결제완료' : '미결제'}</div>
                                            <div>{item?.tid}</div>
                                            <div>{item?.moid}</div>
                                        </td>
                                        <td>변경</td>
                                        <td>
                                            <div>{formatNumberWithCommas(item?.totPrice)}</div>
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <span
                                                id="popup-payment-history"
                                                onClick={() => {
                                                    handleEditInfo(item?.seq);
                                                }}
                                            >
                                                수정
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={8}>데이타가 없습니다.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <Pagination pages={pagesInvoice} params="page-invoice" />
            </div>

            {isPopupVisible && (
                <div id="popup" data-popup="payment-history" data-popup-id={selectedData}>
                    <div className="overlay" onClick={handleClose} />
                    <div className="popup-content">
                        <div className="popup-close" onClick={handleClose} />
                        <div className="popup-title">덴탈잡 결제정보 취소 / 변경</div>
                        <div className="popup-table">
                            <div className="table-row four-column">
                                <div className="table-row-title">아이디</div>
                                <div className="table-row-content left">{popupData?.memberID}</div>
                                <div className="table-row-title">상품명</div>
                                <div className="table-row-content right">{popupData?.goodName}</div>
                            </div>
                            <div className="table-row four-column">
                                <div className="table-row-title">치과명</div>
                                <div className="table-row-content left">{popupData.bizCompany}</div>
                                <div className="table-row-title">결제금액</div>
                                <div className="table-row-content right">
                                    {formatNumberWithCommas(popupData?.totPrice)}
                                </div>
                            </div>
                            <div className="table-row four-column">
                                <div className="table-row-title">결제여부</div>
                                <div className="table-row-content left">
                                    {popupData?.resultCode === '00' ? '결제완료' : '결제오류'}
                                </div>
                                <div className="table-row-title">결제수단</div>

                                <div className="table-row-content right">{getPaymentMethod(popupData?.payMethod)}</div>
                            </div>
                            <div className="table-row">
                                <div className="table-row-title">TID</div>
                                <div className="table-row-content flex-center">{popupData?.tid}</div>
                            </div>
                            <div className="table-row">
                                <div className="table-row-title">주문번호</div>
                                <div className="table-row-content flex-center">{popupData?.moid}</div>
                            </div>
                            <div className="table-row">
                                <div className="table-row-title" />
                                <div
                                    className="table-row-content t-left"
                                    style={{ height: 'auto', paddingBottom: '12px' }}
                                >
                                    <fieldset id="radio-group" className="radio-group">
                                        <div className="item-radioBox">
                                            <input
                                                onChange={handleRadioChange}
                                                type="radio"
                                                name="radio-group"
                                                id="accept"
                                                value="act"
                                            />
                                            <span />
                                            <label htmlFor="accept">
                                                <span>결제확인</span>
                                            </label>
                                        </div>
                                        <div className="item-radioBox">
                                            <input
                                                onChange={handleRadioChange}
                                                type="radio"
                                                name="radio-group"
                                                id="cancel"
                                                value="cancel"
                                            />
                                            <span />
                                            <label htmlFor="cancel">
                                                <span>결제취소</span>
                                            </label>
                                        </div>
                                        <div className="item-radioBox">
                                            <input
                                                onChange={handleRadioChange}
                                                type="radio"
                                                name="radio-group"
                                                id="change"
                                                value="rdo"
                                            />
                                            <span />
                                            <label htmlFor="change">
                                                <span>계좌정보변경</span>
                                            </label>
                                        </div>
                                    </fieldset>
                                    <div className="group-column2 reason-group">
                                        <div className="input-accept">
                                            <div className="reason-group-title">결제일</div>
                                            <div className="datepicker-child">
                                                <DatePicker
                                                    ref={actDateRef}
                                                    onChange={(date) => handleDateChange(date, 'actDate')}
                                                    locale={'ko'}
                                                    placeholderText={'YYYY/MM/DD'}
                                                    dateFormat={'yyyy/MM/dd'}
                                                    selected={actDate}
                                                    disabled={actDateDisable}
                                                />
                                                <i
                                                    className="icon icon-date"
                                                    id="act-date-icon"
                                                    onClick={() => actDateRef.current.setFocus()}
                                                />
                                            </div>
                                        </div>
                                        <div className="input-cancel">
                                            <div className="reason-group-title">취소일</div>
                                            <div className="datepicker-child">
                                                <DatePicker
                                                    ref={cancelDateRef}
                                                    onChange={(date) => handleDateChange(date, 'cancelDate')}
                                                    locale={'ko'}
                                                    placeholderText={'YYYY/MM/DD'}
                                                    dateFormat={'yyyy/MM/dd'}
                                                    selected={cancelDate}
                                                    disabled={cancelDateDisable}
                                                />
                                                <i
                                                    className="icon icon-date"
                                                    id="cancel-date-icon"
                                                    onClick={() => cancelDateRef.current.setFocus()}
                                                />
                                            </div>
                                        </div>
                                        <div className="textChange">
                                            <div className="reason-group-title">입금은행</div>
                                            <div className="reason-group-content" style={{ margin: 'auto' }}>
                                                국민은행 (002837-04-002662)<br></br>
                                                예낭아이앤씨
                                            </div>
                                        </div>
                                    </div>
                                    <div className="group-column3 reason-input">
                                        <div className="reason-input"></div>
                                        <div className="reason-input">
                                            <div className="reason-group-title">취소 사유</div>
                                            <input
                                                type="text"
                                                className="input-reason"
                                                onChange={handleChangeInput}
                                                value={cancelInputValue}
                                                disabled={cancelInputDisable}
                                            />
                                        </div>
                                        <div className="reason-input">
                                            <div className="reason-group-title">입금자명</div>
                                            <input
                                                type="text"
                                                className="input-reason"
                                                onChange={handleChangeInput}
                                                value={chargeInputValue}
                                                disabled={chargeInputDisable}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="popup-button" onClick={handleSave}>
                            등록 / 수정
                        </button>
                    </div>
                </div>
            )}

            {isPopupDocInfo && (
                <div id="popup" data-popup="sp-doc-infor">
                    <div className="overlay" onClick={handleCloseDocInfo} />
                    <div className="popup-content">
                        <div className="popup-close" onClick={handleCloseDocInfo} />
                        <div className="popup-title center">덴탈잡 증빙서류 정보</div>
                        {/* thay style */}
                        <div className="popup-table">
                            <div className="table-row four-column">
                                <div className="table-row-title">증빙구분</div>
                                <div className="table-row-content left">
                                    <select
                                        name="useOpt"
                                        id="useOpt"
                                        value={formData?.useOpt ? formData?.useOpt : ''}
                                        onChange={handleInputChange}
                                    >
                                        <option value=" ">미신청</option>
                                        <option value="0">현금영수증(소득공제)</option>
                                        <option value="1">현금영수증(지출증빙)</option>
                                    </select>
                                </div>
                                <div className="table-row-title">합계</div>
                                <div className="table-row-content right">
                                    {formData?.crPrice ? `${formatNumberWithCommas(formData?.crPrice)} 원` : ''}
                                </div>
                            </div>
                            <div className="table-row four-column">
                                <div className="table-row-title">공급가액</div>
                                <div className="table-row-content left">
                                    {formData?.subPrice ? `${formatNumberWithCommas(formData?.subPrice)} 원` : ''}
                                </div>
                                <div className="table-row-title">부가세</div>
                                <div className="table-row-content right">
                                    {formData?.tax ? `${formatNumberWithCommas(formData?.tax)} 원` : ''}
                                </div>
                            </div>
                            <div className="table-row">
                                <div className="table-row-title">담당자명</div>
                                <div className="table-row-content flex-center">
                                    <input
                                        name="chargerName"
                                        value={formData?.chargerName ? formData?.chargerName : ''}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="table-row">
                                <div className="table-row-title">담당자연락처</div>
                                <div className="table-row-content flex-center" style={{ gap: '15px' }}>
                                    <input
                                        style={{ width: '85%' }}
                                        type="text"
                                        name="buyerTel"
                                        value={
                                            !formData?.buyerTel || formData?.buyerTel !== '--' ? formData?.buyerTel : ''
                                        }
                                        onChange={handleInputChange}
                                        maxLength={13}
                                    />{' '}
                                    <span>(* - 제외)</span>
                                </div>
                            </div>
                            <div className="table-row">
                                <div className="table-row-title">담당자이메일</div>
                                <div className="table-row-content flex-center">
                                    <input
                                        style={{ width: '243px' }}
                                        type="text"
                                        name="emailPart1"
                                        value={formData?.emailPart1}
                                        onChange={handleInputChange}
                                    />
                                    <span>@</span>
                                    <input
                                        style={{ width: '207px' }}
                                        type="text"
                                        name="emailPart2"
                                        value={
                                            formData?.emailDomain
                                                ? formData?.emailDomain === 'zdirect'
                                                    ? formData?.emailPart2
                                                    : formData?.emailDomain
                                                : emailDomainArr[0].value
                                        }
                                        onChange={handleInputChange}
                                        disabled={formData.emailDomain !== 'zdirect'}
                                    />
                                    <select
                                        style={{ width: '190px' }}
                                        name="emailDomain"
                                        id="emailDomain"
                                        onChange={handleEmailDomainChange}
                                        value={formData?.emailDomain}
                                    >
                                        {emailDomainArr.map((domain, index) => (
                                            <option key={index} value={domain.value}>
                                                {domain.option}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="table-row four-column">
                                <div className="table-row-title">증빙신청번호</div>
                                <div className="table-row-content left">
                                    <input
                                        type="number"
                                        placeholder=""
                                        name="receiptNum"
                                        value={formData?.receiptNum}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="table-row-title">현금영수증발급 TID</div>
                                <div className="table-row-content right">
                                    <input
                                        placeholder=""
                                        name="cshrTid"
                                        value={formData?.cshrTid}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="table-row four-column">
                                <div className="table-row-title">현금영수증발급 승인번호</div>
                                <div className="table-row-content left">
                                    <input
                                        placeholder=""
                                        name="cshrApplNum"
                                        value={formData?.cshrApplNum}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="table-row-title">현금영수증발급상태</div>
                                <div className="table-row-content right">
                                    <select
                                        name="cshrResultCode"
                                        id="cshrResultCode"
                                        defaultValue={formData?.cshrResultCode ? formData?.cshrResultCode : ''}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">미신청</option>
                                        <option value="AA">발급대기</option>
                                        <option value="00">발급완료</option>
                                        <option value="01">발급오류</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <button className="popup-button" onClick={handleUpdateInfo}>
                            증빙서류 정보 수정
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MABAA110;
